/**
 * todoSyncTargetsResolver.ts
 *
 * settings.todoSyncTargets(host 를 제거한 path 목록, 혹은 구버전이 저장한 절대 URL 목록)를
 * 실제 폴더 목록의 절대 URL 로 역매핑하는 순수 함수.
 *
 * TodoFolderSync.ts(메모리 폴더 목록)와 TodoDb.ts(IndexedDB 폴더 목록) 양쪽에서 공유해야 하는데,
 * 두 모듈 모두 './todoDB' 를 통해 서로 의존하는 관계라 어느 한쪽이 다른 쪽을 직접 import 하면
 * 순환 참조가 생긴다. 이 모듈은 folders 목록을 인자로 받기만 할 뿐 TodoFolderSync/TodoDb 어느
 * 쪽도 import 하지 않으므로, 각 모듈이 자신이 가진 폴더 목록을 넘겨 안전하게 재사용할 수 있다.
 */

import { davListIncludes } from 'libs/dav/davPath'

interface SyncTargetFolder {
  url: string
}

/**
 * @param syncTargets settings.todoSyncTargets 원본 값 (path 목록 또는 구버전 절대 URL 목록)
 * @param folders 현재 알고 있는 폴더 목록 (절대 URL 을 가진 폴더 객체들)
 * @returns folders 중 syncTargets 에 해당하는 폴더들의 절대 URL 목록.
 *          folders 에 없는 대상(삭제된 폴더 등)은 결과에서 제외된다.
 */
export const resolveSyncTargetUrls = <T extends SyncTargetFolder>(
  syncTargets: readonly string[] | null | undefined,
  folders: readonly T[],
): string[] => {
  if (!Array.isArray(syncTargets) || syncTargets.length === 0) {
    return []
  }

  return folders
    .filter((folder) => davListIncludes(syncTargets, folder.url))
    .map((folder) => folder.url)
}
